module.exports = __webpack_public_path__ + "cfc0fd3da8dcee158b048f2397bd2a63.png";


//////////////////
// WEBPACK FOOTER
// ./work/caoua/img/left.png
// module id = 723
// module chunks = 0